import branding from '../../mixins/branding';

require('./scss/lightswitch.scss');

export default {
    name: 'lightswitch',

    mixins: [branding],

    template: `
        <div class="form-group light-switch-group">
            <div :class="{ 'form-row': true, 'align-items-center': itemsCenter }">
                <div :class="{ 'col': withCols }">
                    <slot
                        ><label for="">{{ text }}</label></slot
                    >
                </div>
                <div :class="{ 'col-3': withCols }">
                    <div
                        class="light-switch"
                        :class="{ 'light-switch-checked': value }"
                        :disabled="disabled"
                        v-on:click="emitInputValue"
                        v-hammer:swipe="emitInputValue"
                    >
                        <div class="light-switch-button">
                            <span>
                                <img svg-inline :src="lightSwitchTickIcon">
                            </span>
                        </div>
                        <span class="light-switch-track"></span>
                        <input type="hidden" v-if="validation" v-validate="validation" :data-vv-as='text.toLowerCase()' v-bind:value="value" :name="name" />
                        <input type="hidden" v-else v-bind:value="value" :name="name" />
                    </div>
                </div>
            </div>
        </div>
    `,

    inject: ['$validator'],

    props: {
        value: {
            type: Boolean,
            default: false,
        },
        text: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        withCols: {
            type: Boolean,
            default: true,
        },
        itemsCenter: {
            type: Boolean,
            default: false,
        },
        validation: Object,
    },

    data() {
        return {
            lightSwitchTickIcon: this.requireLightSwitchTickIcon(),
        };
    },

    methods: {
        emitInputValue() {
            if (this.disabled == false) {
                this.$emit('input', !this.value);
            }
        },
    },
};
